import React, {useState} from 'react';
import {
  Button,
  Switch,
  FormControlLabel,
  FormGroup,
  Container,
  Grid,
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  Typography,
  Stack
} from '@mui/material';
import AssessmentStepper from '../Prepostlearning/Assessment/AddTeat';
import OnlineSetUp from './AdditionData/OnlineSetUp';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ComputerIcon from '@mui/icons-material/Computer';
import {useOnlineContext} from './AdditionData/OnlineTestContext';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {getLMSResultsData} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {enqueueSnackbar} from 'notistack';
import EncryptUtils from 'src/utils/EncryptUtils';
import {useAppContext} from '@context/AppContext';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import {useLocation, useNavigate} from 'react-router-dom';
import FormConstants from '@shared/constants/FormConstants';
import {
  LMS_TYPE,
  BASE_RECORD_ID,
  BASE_UNIQUE_ID,
  LMS_MODULE_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  PARAMS_KEY,
  MOVE_TO_TAB,
  LMS_IS_ADMIN
} from 'src/routes/BaseRoute';
interface AddAssessmentsProps {
  uiFields?: any;
  // eslint-disable-next-line react/boolean-prop-naming
}
const AddAssessments: React.FC<AddAssessmentsProps> = () => {
  const {
    appState: {applicationName}
  } = useAppContext();
  const [dialogOpen, setDialogOpen] = useState(false);
  const {onlineData} = useOnlineContext();
  const {questionsData, setQuestionData} = useOnlineContext();
  const {uiFields, setUiFields} = useOnlineContext();
  const [screenLoader, setScreenLoader] = useState(true);
  // console.log('onlineData', onlineData, uiFields, questionsData);
  function useQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const query = useQuery();
  const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);
  const section = query.get('section');
  const subSection = query.get('subsection');
  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const fileId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_ID
  );
  const moduleId = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_MODULE_ID
  );
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );

  // console.log(
  //   'onRoleChange1',
  //   uniqueId,
  //   fileId,
  //   moduleId,
  //   lmstype,
  //   section,
  //   subSection
  // );

  const navigate = useNavigate();
  // const handleSnackbarClose = () => {
  //   setOpenSnackbar(false);
  // };
  const onRoleChange = async () => {
    // console.log('onRoleChange1', uniqueId, fileId, moduleId);

    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: uniqueId,
      [LMS_TYPE]: 'testing',
      [MOVE_TO_TAB]: 'ModuleMain',
      [LMS_IS_ADMIN]: lmsisAdmin,
      [BASE_UNIQUE_ID]: onlineData?.inserted_id,
      [LMS_MODULE_ID]: onlineData?.module_id
    });
    navigate(
      `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/OnlineTest?${PARAMS_KEY}=${paramsKey}`,
      {
        state: {}
      }
    );
  };
  React.useEffect(() => {
    const initialFetching = async () => {
      if (questionsData.length === 0) {
        if (uiFields) {
          const {sql_data} = uiFields['create_sql'];
          try {
            const data: any = {
              sql_data: sql_data,
              data: {
                module_id: onlineData.inserted_id,
                course_overview_id: uniqueId
              },
              operation: 'QUESTIONSEARCH'
            };
            const encryptRequestData = EncryptUtils.encryptedData(data);
            const result = await getLMSResultsData(applicationName, 'LMS', {
              tk: encryptRequestData
            });
            // setDropDownData((prevData: any[]) => {
            //   console.log('Previous Data:', prevData);
            //   const resultData = result.data; // Assuming `result.data` contains the JSON object

            //   const transformedData = Object.keys(resultData).map(key => ({
            //     Name: key,
            //     Values: resultData[key].map((item: any) => ({
            //       label: item.label,
            //       value: item.value
            //     }))
            //   }));

            //   console.log('Transformed Data:', transformedData);

            //   return [...(prevData || []), ...transformedData];
            // });
            // setOptionsRendered(true);
            const transformedResult = result.data.map((item: any) => {
              return {
                ...item,
                // Parse JSON fields or set them to empty arrays if they are null
                choices: item.choices ? JSON.parse(item.choices) : null,
                correctMatches: item.correctMatches
                  ? JSON.parse(item.correctMatches)
                  : null,
                additionalChoices: item.additionalChoices
                  ? JSON.parse(item.additionalChoices)
                  : null,
                descriptive_enforce_word_limit:
                  item.descriptive_enforce_word_limit
                    ? JSON.parse(item.descriptive_enforce_word_limit)
                        .descriptive_enforce_word_limit
                    : null,
                // Parse the descriptive_enforce_word_limit_length JSON or set it to null
                descriptive_enforce_word_limit_length:
                  item.descriptive_enforce_word_limit_length
                    ? JSON.parse(item.descriptive_enforce_word_limit_length)
                        .descriptive_enforce_word_limit_length
                    : null,
                TrueFalse: item.TrueFalse
                  ? JSON.parse(item.TrueFalse).TrueFalse
                  : null
                // Add any additional transformations here if needed
              };
            });

            setQuestionData(transformedResult);
            setScreenLoader(false);
          } catch (e) {
            setScreenLoader(false);
            const errMessage = getErrorMessage(e);
            enqueueSnackbar(errMessage, SnackBarConfig.getError());
          }
        }
      } else if (questionsData.length > 0) {
        setScreenLoader(false);
      }
    };
    initialFetching();
  }, []);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <Box sx={{overflowY: 'auto', marginBottom: '7vh'}}>
      {!dialogOpen &&
        (screenLoader ? (
          <Stack
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            minHeight={'60vh'}>
            <LoadingScreen />
          </Stack>
        ) : questionsData.length > 0 ? (
          <>
            <Box sx={{mx: 2, paddingTop: 2, paddingBottom: 1, px: 2}}>
              <h4
                style={{
                  paddingTop: '2vh'
                }}>
                Assessment
              </h4>
              <p>
                Setup an online assessment with multiple questions for learners
              </p>
            </Box>
            <Box sx={{mx: 2, p: 2}}>
              <Card
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  p: 2,
                  boxShadow: 2,
                  borderRadius: 2,
                  bgcolor: 'white'
                }}>
                {/* Left Icon Section */}
                <Box
                  sx={{
                    bgcolor: '#FFF7DD',
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 2,
                    mr: 2,
                    width: 64,
                    height: 64
                  }}>
                  <ComputerIcon sx={{fontSize: 32, color: '#FBC02D'}} />
                </Box>

                {/* Content Section */}
                <CardContent
                  onClick={handleOpenDialog}
                  sx={{
                    flexGrow: 1,
                    p: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}>
                  <Typography variant="h6" sx={{fontWeight: 'bold'}}>
                    online
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Questions: {questionsData.length} • Marks:{' '}
                    {questionsData.reduce(
                      (acc: any, q: {QuestionMarks_id: any}) =>
                        acc + q.QuestionMarks_id,
                      0
                    )}{' '}
                    • Duration:
                    {onlineData.assessment_time_limit_type_id === 1
                      ? onlineData.overallTime_in_minutes
                      : onlineData.assessment_time_limit_type_id === 2
                        ? onlineData.time_per_question_in_minutes *
                          questionsData.length
                        : 'No Time Limit'}
                  </Typography>
                </CardContent>

                {/* Right Actions Section */}
                {/* <Box
                  sx={{
                    alignItems: 'center',
                    flexDirection: 'column',
                    gap: 1
                  }}>
                  {onlineData?.Publish ? (
                    <Chip
                      label="PUBLISHED"
                      color="success"
                      size="small"
                      sx={{fontWeight: 'bold'}}
                    />
                  ) : (
                    <Chip
                      label="DRAFT"
                      color="info"
                      size="small"
                      sx={{fontWeight: 'bold'}}
                    />
                  )}
                </Box> */}
              </Card>
            </Box>
          </>
        ) : (
          <Container
            sx={{
              borderRadius: '8px',
              maxWidth: '100% !important',
              py: '3vh'
            }}>
            <Box
              sx={{
                backgroundColor: 'white',
                minHeight: '66vh',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
              <Box>
                <h4
                  style={{
                    paddingTop: '2vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                  No Assessment added
                </h4>
                <Grid item xs={12} sx={{margin: '2vh 0'}}>
                  <p style={{paddingBottom: '1vh'}}>
                    Test learner knowledge using a customizable online
                    assessment
                  </p>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                    <Button
                      sx={{
                        marginLeft: '5vh',
                        maxWidth: 'max-content',
                        marginBottom: '1vh '
                      }}
                      variant="contained"
                      color="info"
                      onClick={handleOpenDialog}>
                      Add Assessment
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Container>
        ))}
      {dialogOpen && (
        <Container
          sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            maxWidth: '100% !important',
            py: '3vh'
          }}>
          {' '}
          <OnlineSetUp onClose={handleCloseDialog} />
        </Container>
      )}
    </Box>
  );
};

export default AddAssessments;
